export default {"src":"/_next/static/media/dr-congo.9edf1280.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};